// extracted by mini-css-extract-plugin
module.exports = {"form_control":"ServiceCharge_form_control__V_HMY","disabled":"ServiceCharge_disabled__24S2s","animate":"ServiceCharge_animate__3maz2"};